export default __webpack_public_path__ + "static/media/home-creative-agency-img-02.b3340062.jpg";